<template>
  <div class="descriptions">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'Descriptions'
}
</script>
<style lang="stylus" scoped>
.descriptions {
  background-color: #FFFBF4;
  padding: 20px 50px;
}
</style>